import { render, staticRenderFns } from "./TblRowMblView.vue?vue&type=template&id=3b0a2c32&scoped=true"
import script from "./TblRowMblView.vue?vue&type=script&lang=js"
export * from "./TblRowMblView.vue?vue&type=script&lang=js"
import style0 from "./TblRowMblView.vue?vue&type=style&index=0&id=3b0a2c32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a2c32",
  null
  
)

export default component.exports